// src/roles.ts
const oidcRoles = {
	ADMIN: "overbookd_admin",
	USER: "overbookd_user",
	GUEST: "overbookd_guest"
};
const wikiOidcRoles = { EDITOR: "wiki_editor" };
const overviewOidcRoles = { VIEWER: "overview_viewer" };
const vaultwardenOidcRoles = { USER: "vaultwarden_user" };
// src/utils.ts
const OIDC_ROLES_CLAIMS = "urn:zitadel:iam:org:project:roles";
const OIDC_METADATA_CLAIMS = "urn:zitadel:iam:user:metadata";
export { OIDC_METADATA_CLAIMS, OIDC_ROLES_CLAIMS, oidcRoles, overviewOidcRoles, vaultwardenOidcRoles, wikiOidcRoles };

//# sourceMappingURL=index.mjs.map